import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslationModule } from '../translation/translation.module';
import { FilterEditorComponent } from './filter-editor/filter-editor.component';
import { FilterLabelPipe } from './filter-label.pipe';
import { FiltersComponent } from './filters/filters.component';
import { FilterEditorInputComponent } from './filter-editor/filter-editor-input/filter-editor-input.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';

@NgModule({
  declarations: [
    FiltersComponent,
    FilterEditorComponent,
    FilterLabelPipe,
    FilterEditorInputComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatSlideToggleModule,
    MatRadioModule,
    TranslationModule,
    MatDatepickerModule,
  ],
  exports: [FiltersComponent, FilterEditorComponent],
})
export class FilterModule {}
